<app-pharm-header></app-pharm-header>

<div class="pharmacy-store-container">
  <app-pharm-sidebar></app-pharm-sidebar>

  <div class="main-content">
    <h2>🏪 Pharmacist Store</h2>

    <!-- 🔍 Filter Bar -->
    <div class="filters">
      <input type="text" [(ngModel)]="filters.product_name" placeholder="Filter by Product" />
      <input type="text" [(ngModel)]="filters.category" placeholder="Filter by Category" />
      <input type="text" [(ngModel)]="filters.unit" placeholder="Filter by Unit" />
      <input type="text" [(ngModel)]="filters.origin" placeholder="Filter by Origin" />
      <input type="number" [(ngModel)]="filters.quantity" placeholder="Min Quantity" />

      <label>Start Expiry:</label>
      <input type="date" [(ngModel)]="filters.expiry_start" />

      <label>End Expiry:</label>
      <input type="date" [(ngModel)]="filters.expiry_end" />

      <button (click)="resetFilters()">❌ Clear Filters</button>
    </div>

    <!-- 🧾 Stock Table -->
    <table>
      <thead>
        <tr>
          <th>Product</th>
          <th>Category</th>
          <th>Unit</th>
          <th>Quantity</th>
          <th>Min Stock</th>
          <th>Expiry</th>
          <th>Origin</th>
          <th>Created</th>
          <th>Transfer</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredStock">
  <td><span class="label">Product:</span> {{ item.product_name }}</td>
  <td><span class="label">Category:</span> {{ item.category }}</td>
  <td><span class="label">Unit:</span> {{ item.unit }}</td>
  <td><span class="label">Quantity:</span> {{ item.store_quantity }}</td>
  <td><span class="label">Min Stock:</span> {{ item.min_stock_level }}</td>
  <td><span class="label">Expiry:</span> {{ item.expiry_date | date: 'shortDate' }}</td>
  <td><span class="label">Origin:</span> {{ item.from_store || '—' }}</td>
  <td><span class="label">Created:</span> {{ item.product_created_at | date: 'short' }}</td>
  <td>
    <span class="label">Transfer:</span>
    <button (click)="openTransferModal(item)">Transfer</button>
  </td>
</tr>

      </tbody>
    </table>

    <!-- 📦 Transfer Modal -->
    <!-- ✅ Transfer Modal -->
<div class="modal" *ngIf="selectedItem">
  <h3>Transfer {{ selectedItem.product_name }}</h3>

  <label>Quantity:</label>
  <input type="number" [(ngModel)]="transferQuantity" />

  <label>To Store:</label>
  <select [(ngModel)]="toStoreId">
    <option value="0" disabled>Select Store</option>
    <option *ngFor="let store of otherStores" [value]="store.id">
      {{ store.name }}
    </option>
  </select>

  <!-- ✅ Note textarea -->
  <label>Note (optional):</label>
  <textarea [(ngModel)]="transferNote" rows="3" placeholder="Add note..."></textarea>

  <div class="modal-actions">
    <button (click)="transferItem()">✅ Transfer</button>
    <button (click)="closeModal()">❌ Cancel</button>
  </div>
</div>

  </div>
</div>
